const SMALL_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "but",
  "by",
  "for",
  "in",
  "nor",
  "of",
  "on",
  "or",
  "per",
  "the",
  "to",
  "vs",
  "via",
])

/**
 * Title Case for generated headings: capitalize each word except short
 * connectors mid-title; leave words with digits or internal capitals (agent
 * names, ids, "QA") as written.
 */
export function titleCase(value: string): string {
  const words = value.trim().split(/\s+/)
  return words
    .map((word, index) => {
      if (/\d/.test(word) || word.slice(1) !== word.slice(1).toLowerCase()) {
        return word
      }
      if (
        index !== 0 &&
        index !== words.length - 1 &&
        SMALL_WORDS.has(word.toLowerCase())
      ) {
        return word.toLowerCase()
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(" ")
}
